import {mapRecordToItems} from '@/helpers/mapRecordToItems.helper';
import colors from 'vuetify/lib/util/colors';

export enum ApplicationState {
    PENDING = 'pending',
    WAITING_LIST = 'waitingList',
    IN_PROGRESS = 'inProgress',
    ACCEPTED = 'accepted',
    REJECTED = 'rejected',
}

export namespace ApplicationState {
    type Data = {
        text: string,
        vueColor: typeof colors.grey,
    }

    export const Record: Record<ApplicationState, Data> = {
        [ApplicationState.PENDING]: { text: 'Ausstehend', vueColor: colors.grey },
        [ApplicationState.WAITING_LIST]: { text: 'Warteliste', vueColor: colors.amber },
        [ApplicationState.IN_PROGRESS]: { text: 'In Bearbeitung', vueColor: colors.blue },
        [ApplicationState.ACCEPTED]: { text: 'Angenommen', vueColor: colors.green },
        [ApplicationState.REJECTED]: { text: 'Abgelehnt', vueColor: colors.red },
    };

    export const Items = mapRecordToItems(Record);
}
